import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fsMessageTransform'
})
export class FsMessageTransformPipe implements PipeTransform {

  transform(value: string, component?: string): string {
    if (value.match(/401/g) && component === 'login') {
      return 'Wrong login or password'
    }
    return value;
  }

}
